export default __webpack_public_path__ + "static/media/Sad3.7b834858.png";